import Modal from 'react-bootstrap/Modal';
import { HotTable } from '@handsontable/react';
import React, { useState, useEffect, useRef } from 'react';

import 'handsontable/dist/handsontable.full.min.css';

import Handsontable from 'handsontable/base';
import { registerAllModules } from 'handsontable/registry';
import { Button, createTheme, Popover } from '@mui/material';
import { useAuth } from 'react-oidc-context';
import SessionExpiredModal from '../../../utils/SessionExpiredModal';
import { ArrowRightIcon } from '@mui/x-date-pickers';
import ForwardModal from './ForwardModal';

registerAllModules();

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

function formatABN(abn) {
  if (abn == 'NOT PROVIDED') {
    return abn;
  }

  // Remove any non-digit characters in case the input is not clean
  let str = abn.replace(/\D/g, '');

  // Check if the input is exactly 11 digits, if not, handle as needed
  if (str.length !== 11) {
    console.error('Invalid ABN: ABN must be exactly 11 digits');
    return null;
  }

  // Insert spaces to format as ABN
  return str.replace(/(\d{2})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
}

export default ({ show, selectedClient, onHide, selectedDocument, onShow }) => {
  const modalContentRef = useRef(null);

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);
  const [
    isPDFLoading,
    setIsPDFLoading,
  ] = useState(false);
  const [
    pdfUrl,
    setPdfUrl,
  ] = useState('');

  const [
    forwardModalShow,
    setForwardModalShow,
  ] = useState(false);

  const auth = useAuth();

  const [
    anchorEl,
    setAnchorEl,
  ] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  useEffect(() => {
    setIsPDFLoading(true);
    console.log(selectedDocument);
    if (selectedDocument?.client_id) {
      // Fetch the PDF when the component mounts
      fetch(`${window.origin}/api/client-communication/${selectedDocument.client_id}/${selectedDocument.filename}`, {
        headers: {
          'Authorization': `Bearer ${auth.user?.access_token}`,
          'Cache-Control': 'no-cache',
          'If-None-Match': '0',
        },
      }) // Replace with your actual API endpoint
        .then((response) => {
          if (!response.ok) {
            throw new Error('Failed to fetch the PDF');
          }
          return response.blob();
        })
        .then((blob) => {
          // Create an object URL from the Blob
          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
          console.log('URL:', url);
          setIsPDFLoading(false); // PDF is ready
        })
        .catch((err) => {
          console.log(err.message);
          setIsPDFLoading(false); // Stop loading on error
        });
    }
  }, [selectedDocument]);

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        dialogClassName="modal-70w"
        aria-labelledby="example-custom-modal-styling-title"
        style={{}}
        enforceFocus={false}
        restoreFocus={false}
      >

        <Modal.Body style={{}}>

          <div style={{ display: 'flex', flexDirection: 'row', color: 'rgb(0, 15, 30, 0.7)' }}>
            <iframe
              src={pdfUrl}
              width="100%"
              title="PDF Document"
              style={{ border: 'none', flex: 2, height: '85vh', borderRadius: '1.2vw' }}
            />

            <div style={{ flex: 1, padding: '1vw', marginLeft: '2vw', display: 'flex', flexDirection: 'column' }}>
              <div style={{ flex: 1 }}>
                <div style={{ marginBottom: '1vw' }}>
                  <p style={{ fontSize: '1.1vw', margin: 0, marginBottom: '0.6vw', fontWeight: '500' }}>Document Preview</p>
                  {/* <p style={{fontSize: '0.65vw', margin: 0}}>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout</p> */}
                </div>
                <div style={{ paddingTop: '2vw' }}>
                  <p style={{ fontSize: '0.7vw', margin: 0, marginBottom: '0.3vw' }}>File name</p>
                  <p style={{ fontSize: '0.85vw', margin: 0 }}>{selectedDocument?.filename}</p>

                </div>
                <div style={{ paddingTop: '2vw' }}>
                  <p style={{ fontSize: '0.7vw', margin: 0, marginBottom: '0.3vw' }}>Document Type</p>
                  <p style={{ fontSize: '0.85vw', margin: 0 }}>
                    {selectedDocument?.document_type}
                    {' '}
                    Document
                  </p>

                </div>
                <div style={{ paddingTop: '2vw' }}>
                  <p style={{ fontSize: '0.7vw', margin: 0, marginBottom: '0.3vw' }}>Client</p>
                  <p style={{ fontSize: '0.85vw', margin: 0 }}>{selectedDocument?.client_name}</p>

                </div>

                <div style={{ paddingTop: '2vw' }}>
                  <p style={{ fontSize: '0.7vw', margin: 0, marginBottom: '0.3vw' }}>Created At</p>
                  <p style={{ fontSize: '0.85vw', margin: 0 }}>{selectedDocument?.created_at}</p>

                </div>
              </div>
              {/* <div style={{alignSelf: 'flex-end', width: '100%'}}>
                            <Button  onClick={() => {setForwardModalShow(true)}} variant="outlined" style={{
                            borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.05vw'
                        , width: '100%', marginTop: '1vw'}}>Forward to client</Button>
                        </div> */}
              <div style={{ alignSelf: 'flex-end', width: '100%' }}>
                <Button
                  aria-describedby={id}
                  onClick={handleClick}
                  variant="outlined"
                  style={{
                    borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.05vw',
                    width: '100%', marginTop: '1vw' }}
                >
                  Forward to client
                </Button>
                <Button
                  onClick={onHide}
                  variant="outlined"
                  style={{ display: 'block',
                    borderColor: 'rgb(255, 255, 255, 1)', color: '#1c6c6c', padding: '0.3vw 0.5vw', border: 'none', backgroundColor: 'rgb(255, 255, 255, 0)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '0.9vw', fontWeight: 500, letterSpacing: '0.08vw',
                    marginTop: '0vw', marginLeft: 'auto', marginRight: 'auto' }}
                >
                  Close
                </Button>
              </div>

              {/* <div ref={modalContentRef} style={{ position: 'relative' }}> */}

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                style={{ borderRadius: '1vw' }}
              >
                <ForwardModal show={forwardModalShow} onHide={handleClose} documentId={selectedDocument?.file_id} />
              </Popover>
              {/* </div> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* <ForwardModal show={forwardModalShow} onHide={() => {setForwardModalShow(false)}} /> */}
    </>
  );
};


